"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const CSS = {
    sidebar: 'c-Sidebar',
};
const styles = {
    [CSS.sidebar]: {
        width: '20%',
        'min-width': '350px',
        display: 'flex',
        'flex-direction': 'column',
    },
};
(0, theme_1.addStyles)(styles);
class Sidebar {
    view(children) {
        return (0, mithril_1.m)('div', {
            className: CSS.sidebar,
        }, children);
    }
}
exports.Sidebar = Sidebar;
//# sourceMappingURL=sidebar.component.js.map